import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Context Providers
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";

// API Config
import { API } from "@/config/api";
export { API };

// Pages
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import FinancialConsulting from "@/pages/FinancialConsulting";
import MediaServices from "@/pages/MediaServices";
import FashionHouse from "@/pages/FashionHouse";
import ArtGallery from "@/pages/ArtGallery";
import TradingHub from "@/pages/TradingHub";
import TradingTerminal from "@/pages/TradingTerminal";
import Portfolio from "@/pages/Portfolio";
import Profile from "@/pages/Profile";
import AffiliatePortal from "@/pages/AffiliatePortal";
import AboutPage from "@/pages/AboutPage";
import GildedStudy from "@/pages/GildedStudy";
import WalletPage from "@/pages/WalletPage";
import CopyTrading from "@/pages/CopyTrading";
import Staking from "@/pages/Staking";
import RealEstate from "@/pages/RealEstate";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RiskDisclaimer from "@/pages/RiskDisclaimer";
import PaymentSuccess from "@/pages/PaymentSuccess";
import TradeJournal from "@/pages/TradeJournal";
import PortfolioAnalytics from "@/pages/PortfolioAnalytics";
import BookingPage from "@/pages/BookingPage";
import AIAssistant from "@/pages/AIAssistant";
import Web3Services from "@/pages/Web3Services";
import SubscriptionPage from "@/pages/SubscriptionPage";
import SecuritySettings from "@/pages/SecuritySettings";
import BookPreorder from "@/pages/BookPreorder";

// Components
import Navbar from "@/components/Navbar";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";
import TradingProtectedRoute from "@/components/TradingProtectedRoute";

// Main App Router Component
function AppRouter() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/the-wealth-lexicon" element={<BookPreorder />} />
        <Route path="/fashion" element={<FashionHouse />} />
        <Route path="/art-gallery" element={<ArtGallery />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<RiskDisclaimer />} />
        
        {/* Protected Routes - Require Login */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/financial-consulting" element={
          <ProtectedRoute>
            <FinancialConsulting />
          </ProtectedRoute>
        } />
        <Route path="/media-services" element={
          <ProtectedRoute>
            <MediaServices />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        <Route path="/affiliate" element={
          <ProtectedRoute>
            <AffiliatePortal />
          </ProtectedRoute>
        } />
        <Route path="/affiliate-portal" element={
          <ProtectedRoute>
            <AffiliatePortal />
          </ProtectedRoute>
        } />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/gilded-study" element={<GildedStudy />} />
        <Route path="/wallet" element={
          <ProtectedRoute>
            <WalletPage />
          </ProtectedRoute>
        } />
        <Route path="/payment/success" element={
          <ProtectedRoute>
            <PaymentSuccess />
          </ProtectedRoute>
        } />
        <Route path="/order/success" element={
          <ProtectedRoute>
            <PaymentSuccess />
          </ProtectedRoute>
        } />
        <Route path="/subscription" element={
          <ProtectedRoute>
            <SubscriptionPage />
          </ProtectedRoute>
        } />
        <Route path="/security" element={
          <ProtectedRoute>
            <SecuritySettings />
          </ProtectedRoute>
        } />
        
        {/* Trading Routes - Require Login */}
        <Route path="/trading" element={
          <TradingProtectedRoute>
            <TradingTerminal />
          </TradingProtectedRoute>
        } />
        <Route path="/trading/courses" element={
          <TradingProtectedRoute>
            <TradingHub />
          </TradingProtectedRoute>
        } />
        <Route path="/portfolio" element={
          <TradingProtectedRoute>
            <Portfolio />
          </TradingProtectedRoute>
        } />
        <Route path="/copy-trading" element={
          <TradingProtectedRoute>
            <CopyTrading />
          </TradingProtectedRoute>
        } />
        <Route path="/staking" element={
          <TradingProtectedRoute>
            <Staking />
          </TradingProtectedRoute>
        } />
        <Route path="/real-estate" element={
          <TradingProtectedRoute>
            <RealEstate />
          </TradingProtectedRoute>
        } />
        <Route path="/trade-journal" element={
          <TradingProtectedRoute>
            <TradeJournal />
          </TradingProtectedRoute>
        } />
        <Route path="/portfolio-analytics" element={
          <TradingProtectedRoute>
            <PortfolioAnalytics />
          </TradingProtectedRoute>
        } />
        <Route path="/ai-assistant" element={
          <ProtectedRoute>
            <AIAssistant />
          </ProtectedRoute>
        } />
        <Route path="/web3-services" element={<Web3Services />} />
      </Routes>
      <Toaster position="top-right" />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
